/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const getSliceLimitDummyData = () => {
    return {
        body: {
            Exch: "N",
            ExchType: "D",
            Message: "Success",
            Qtylimit: 1800,
            ScripCode: 48840,
            SliceEnable: "Y",
            Status: 0,
        },
        head: {
            responseCode: "5PRQCheckIsSliceEnable",
            status: "0",
            statusDescription: "Success",
        },
    };
};
